export default __webpack_public_path__ + "560bece7822899d19b52e99cfd3e368e.svg";